import React,{useReducer} from 'react';
import {Link} from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { SVGICON } from '../constant/theme';

const svgBlogData = [
    {Iconname : '2 User.svg', svgtype : SVGICON.userdouble,},
    {Iconname : '3 User.svg', svgtype : SVGICON.userthree},
    {Iconname : 'Activity.svg', svgtype : SVGICON.Activity},
    {Iconname : 'Add User.svg', svgtype : SVGICON.adduser},
    {Iconname : 'Bag.svg', svgtype : SVGICON.Bag},
    {Iconname : 'Bag-3.svg', svgtype : SVGICON.Bag3},
    {Iconname : 'Bookmark.svg', svgtype : SVGICON.Bookmark},
    {Iconname : 'Buy.svg', svgtype : SVGICON.Buy},
    {Iconname : 'Calendar.svg', svgtype : SVGICON.Calendar},
    {Iconname : 'Call.svg', svgtype : SVGICON.Call},
    {Iconname : 'Calling.svg', svgtype : SVGICON.Calling},
    {Iconname : 'Call-Missed.svg', svgtype : SVGICON.CallMissed},
    {Iconname : 'Call-Silent.svg', svgtype : SVGICON.CallSilent},
    {Iconname : 'Camera.svg', svgtype : SVGICON.Camera},
    {Iconname : 'Category.svg', svgtype : SVGICON.Category},
    {Iconname : 'Chart.svg', svgtype : SVGICON.Chart},
    {Iconname : 'Chat.svg', svgtype : SVGICON.Chat},
    {Iconname : 'Close-Square.svg', svgtype : SVGICON.Closesquare},
    {Iconname : 'Danger.svg', svgtype : SVGICON.Danger},
    {Iconname : 'Delete.svg', svgtype : SVGICON.Delete},
    {Iconname : 'Discount.svg', svgtype : SVGICON.Discount},
    {Iconname : 'Discovery.svg', svgtype : SVGICON.Discovery},
    {Iconname : 'Document.svg', svgtype : SVGICON.Document},
    {Iconname : 'Download.svg', svgtype : SVGICON.Download},
    {Iconname : 'Edit.svg', svgtype : SVGICON.Edit},
    {Iconname : 'Edit-Square.svg', svgtype : SVGICON.Editsquare},
    {Iconname : 'Filter.svg', svgtype : SVGICON.Filter},
    {Iconname : 'Filter-2.svg', svgtype : SVGICON.Filter2},
    {Iconname : 'Folder.svg', svgtype : SVGICON.Folder},
    {Iconname : 'Game.svg', svgtype : SVGICON.Game},
    {Iconname : 'Graph.svg', svgtype : SVGICON.Graph},
    {Iconname : 'Heart.svg', svgtype : SVGICON.Heart},
    {Iconname : 'Hide.svg', svgtype : SVGICON.Hide},
    {Iconname : 'Home.svg', svgtype : SVGICON.HomeSvg},
    {Iconname : 'Image.svg', svgtype : SVGICON.Image},
    {Iconname : 'Image-3.svg', svgtype : SVGICON.Image3},
    {Iconname : 'Info-Circle.svg', svgtype : SVGICON.Infocircle},
    {Iconname : 'Info-Square.svg', svgtype : SVGICON.Infosquare},
    {Iconname : 'Location.svg', svgtype : SVGICON.Location},
    {Iconname : 'Lock.svg', svgtype : SVGICON.Lock},
    {Iconname : 'login.svg', svgtype : SVGICON.login},
    {Iconname : 'Logout.svg', svgtype : SVGICON.Logoutsvg},
    {Iconname : 'Message.svg', svgtype : SVGICON.Messagesvg},
    {Iconname : 'More-Circle.svg', svgtype : SVGICON.Morecircle},
    {Iconname : 'Notification.svg', svgtype : SVGICON.Notificationsvg},
    {Iconname : 'Paper.svg', svgtype : SVGICON.Paper},
    {Iconname : 'Paper-Download.svg', svgtype : SVGICON.Paperdownload},
    {Iconname : 'Paper-Fail.svg', svgtype : SVGICON.Paperfail},
    {Iconname : 'Password.svg', svgtype : SVGICON.Password},
    {Iconname : 'Pape-Plus.svg', svgtype : SVGICON.Papeplus},
    {Iconname : 'Play.svg', svgtype : SVGICON.Play},
    {Iconname : 'Plus.svg', svgtype : SVGICON.Plus},
    {Iconname : 'Profile.svg', svgtype : SVGICON.Profile},
    {Iconname : 'Scan.svg', svgtype : SVGICON.Scan},
    {Iconname : 'Search.svg', svgtype : SVGICON.Search},
    {Iconname : 'Send.svg', svgtype : SVGICON.Send},
    {Iconname : 'Setting.svg', svgtype : SVGICON.Setting},
    {Iconname : 'Shielddone.svg', svgtype : SVGICON.Shielddone},
    {Iconname : 'Shield-Fail.svg', svgtype : SVGICON.Shieldfail},
    {Iconname : 'Show.svg', svgtype : SVGICON.Show},
    {Iconname : 'Star.svg', svgtype : SVGICON.Star},
    {Iconname : 'Swap.svg', svgtype : SVGICON.Swap},
    {Iconname : 'Ticket.svg', svgtype : SVGICON.Ticket},
    {Iconname : 'TicketStar.svg', svgtype : SVGICON.TicketStar},
    {Iconname : 'TicketSquare.svg', svgtype : SVGICON.TicketSquare},
    {Iconname : 'Timecircle.svg', svgtype : SVGICON.Timecircle},
    {Iconname : 'Time-Square.svg', svgtype : SVGICON.TimeSquare},
    {Iconname : 'Unlock.svg', svgtype : SVGICON.Unlock},
    {Iconname : 'Upload.svg', svgtype : SVGICON.Upload},
    {Iconname : 'Video.svg', svgtype : SVGICON.Video},
    {Iconname : 'Voice.svg', svgtype : SVGICON.Voice},
    {Iconname : 'Voice-3.svg', svgtype : SVGICON.Voice3},
    {Iconname : 'Volume-Down.svg', svgtype : SVGICON.Volumedown},
    {Iconname : 'Volume-Off.svg', svgtype : SVGICON.VolumeOff},
    {Iconname : 'Volume-Up.svg', svgtype : SVGICON.VolumeUp},
    {Iconname : 'Wallet.svg', svgtype : SVGICON.Wallet},
    {Iconname : 'Work.svg', svgtype : SVGICON.Work},    
    {Iconname : 'Arrow-Down-Circle.svg', svgtype : SVGICON.ArrowDownCircle},
    {Iconname : 'Arrow-Left-Circle.svg', svgtype : SVGICON.ArrowLeftCircle},
    {Iconname : 'Arrow-Right-Circle.svg', svgtype : SVGICON.ArrowRightCircle},
    {Iconname : 'Arrow-Up-Circle.svg', svgtype : SVGICON.ArrowUpCircle},
    {Iconname : 'Arrow-Down.svg', svgtype : SVGICON.ArrowDown},
    {Iconname : 'Arrow-Down-2.svg', svgtype : SVGICON.ArrowDown2},
    {Iconname : 'Arrow-Down-3.svg', svgtype : SVGICON.ArrowDown3},
    {Iconname : 'Arrow-Left.svg', svgtype : SVGICON.ArrowLeft},
    {Iconname : 'Arrow-Left-2.svg', svgtype : SVGICON.ArrowLeft2},
    {Iconname : 'Arrow-Left-3.svg', svgtype : SVGICON.ArrowLeft3},
    {Iconname : 'Arrow-Right.svg', svgtype : SVGICON.ArrowRight},
    {Iconname : 'Arrow-Right-2.svg', svgtype : SVGICON.ArrowRight2},
    {Iconname : 'Arrow-Right-3.svg', svgtype : SVGICON.ArrowRight3},
    {Iconname : 'Arrow-Down-Square.svg', svgtype : SVGICON.ArrowDownSquare},
    {Iconname : 'Arrow-Left-Square.svg', svgtype : SVGICON.ArrowLeftSquare},
    {Iconname : 'Arrow-Right-Square.svg', svgtype : SVGICON.ArrowRightSquare},
    {Iconname : 'Arrow-Up.svg', svgtype : SVGICON.ArrowUp},
    {Iconname : 'Arrow-Up-2.svg', svgtype : SVGICON.ArrowUp2},
    {Iconname : 'Arrow-Up-3.svg', svgtype : SVGICON.ArrowUp3},
    {Iconname : 'Arrow-Up-Square.svg', svgtype : SVGICON.ArrowUpSquare},

];

const initialState = false;
const reducer = (state, action) =>{   
	switch (action.type){
		case 'imageModal':
			return { ...state, imageModal: !state.imageModal, content : action.content}
		case 'svgModal':
			return { ...state, svgModal: !state.svgModal, content : action.content, title: action.title}			
		default:
			return state
	}	
}

const SvgIcon = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return (
        <div className="container">
            <div className="card-body svg-area card">
                <div className="card-header">
                    <h3 className="h-title">Salero Icons</h3>
                </div>
                <div className="row">
                    {svgBlogData.map((item, ind)=>(
                        <div className="col-xl-2 col-lg-3 col-xxl-3 col-md-4 col-sm-6 col-12" key={ind}>	
                            <div className="svg-icons-ov">
                                <div className="svg-icons-prev">
                                    <div dangerouslySetInnerHTML={{ __html: item.svgtype }} />
                                </div>
                                <div className="svg-classname">{item.Iconname}</div>
                                <div className="svg-icon-popup">
                                    <Link to={"#"}  onClick={() => dispatch({type:'imageModal', content: item.Iconname })} className="btn btn-sm btn-brand"><i className="fa-solid fa-image"></i></Link>
                                    <Link to={"#"} onClick={() => dispatch({type:'svgModal', content: item.Iconname, title : item.svgtype })} className="btn btn-sm btn-brand"><i className="fa fa-code"></i></Link>
                                </div>
                                
                            </div>
                        </div>
                    ))}

                </div>
                <Modal className="modal fade" show={state.imageModal} onHide={()=>dispatch({type:'imageModal'})} centered>                                
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="svg_img_label_Brassieresvg">{state.content}</h5>
                            <button type="button" className="btn-close" onClick={() => dispatch({type:'imageModal'})}></button>
                        </div>
                        <div className="modal-body">                               
                            <pre>                           
{`import MyImage from "../images/iconly/Bulk/${state.content}";
export default function Imageblog() {   
  return  
    <div>
       <img src={MyImage} alt="Example" />   
    </div>
}`}
;
                            </pre>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => dispatch({type:'imageModal'})}>Close</button>
                        </div>
                    </div>
                    
                </Modal>
                <Modal className="modal fade" show={state.svgModal} onHide={()=>dispatch({type:'svgModal'})} centered >                    
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="svg_inline_label_Brassieresvg">{state.content}</h5>
                            <button type="button" className="btn-close"   onClick={() => dispatch({type:'svgModal'})}>
                            </button>
                        </div>
                        <div className="modal-body">
                            {/* <pre>&lt;svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"&gt;
&lt;path d="M9.34933 14.8577C5.38553 14.8577 2 15.47 2 17.9174C2 20.3666 5.364 21 9.34933 21C13.3131 21 16.6987 20.3877 16.6987 17.9404C16.6987 15.4911 13.3347 14.8577 9.34933 14.8577Z" fill="var(--primary)"/&gt;
&lt;path opacity="0.4" d="M9.34935 12.5248C12.049 12.5248 14.2124 10.4062 14.2124 7.76241C14.2124 5.11865 12.049 3 9.34935 3C6.65072 3 4.48633 5.11865 4.48633 7.76241C4.48633 10.4062 6.65072 12.5248 9.34935 12.5248Z" fill="var(--primary)"/&gt;
&lt;path opacity="0.4" d="M16.1734 7.84875C16.1734 9.19507 15.7605 10.4513 15.0364 11.4948C14.9611 11.6021 15.0276 11.7468 15.1587 11.7698C15.3407 11.7995 15.5276 11.8177 15.7184 11.8216C17.6167 11.8704 19.3202 10.6736 19.7908 8.87118C20.4885 6.19676 18.4415 3.79543 15.8339 3.79543C15.5511 3.79543 15.2801 3.82418 15.0159 3.87688C14.9797 3.88454 14.9405 3.90179 14.921 3.93246C14.8955 3.97174 14.9141 4.02253 14.9395 4.05607C15.7233 5.13216 16.1734 6.44207 16.1734 7.84875Z" fill="var(--primary)"/&gt;
&lt;path d="M21.7791 15.1693C21.4317 14.444 20.5932 13.9466 19.3172 13.7023C18.7155 13.5586 17.0853 13.3545 15.5697 13.3832C15.5472 13.3861 15.5344 13.4014 15.5325 13.411C15.5295 13.4263 15.5364 13.4493 15.5658 13.4656C16.2663 13.8048 18.9738 15.2805 18.6333 18.3928C18.6186 18.5289 18.7292 18.6439 18.8671 18.6247C19.5335 18.5318 21.2478 18.1705 21.7791 17.0475C22.0736 16.4534 22.0736 15.7635 21.7791 15.1693Z" fill="var(--primary)"/&gt;
&lt;/svg&gt;</pre> */}
<pre>   
   {state.title}    
</pre>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => dispatch({type:'svgModal'})}>Close</button>
                        </div>
                    </div>
                    
                </Modal>
            </div>    
        
        </div>

    );
};

export default SvgIcon;
